<template>
    <div class="recipe--ingredients">
        <h2>Ingredienser</h2>

        <form class="recipe--servings">
            <div class="recipe--servings-inner">
                <label for="servings-input" class="recipe--servings-label"> Portioner </label>

                <input
                    id="servings-input"
                    type="number"
                    v-model.number="servings"
                    min="0.1"
                    @blur="normalizeServings"
                    class="recipe--servings-input"
                />
            </div>
        </form>

        <table>
            <tbody>
                <tr v-for="ingredient in orderedIngredients" :key="ingredient.id" itemprop="recipeIngredient">
                    <td class="recipe--ingredient-qty">
                        {{ scaledQuantity(ingredient) }}
                        {{ ingredientUnit(ingredient) }}
                        {{ ingredientName(ingredient) }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import _ from 'lodash';
import state from '../state.js';

export default {
    props: {
        ingredients: {
            type: Array,
            required: true
        },
        recipeServings: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            state,
            servings: this.recipeServings || 1
        };
    },

    mounted() {
        this.state.selectedServings = this.servings;
    },

    watch: {
        servings(newVal) {
            this.state.selectedServings = newVal;
        }
    },

    computed: {
        orderedIngredients() {
            return _.orderBy(this.ingredients, 'id', 'asc');
        }
    },

    methods: {
        scaledQuantity(ingredient) {
            if (!this.recipeServings || !this.servings) {
                return ingredient.quantity;
            }

            const factor = this.servings / this.recipeServings;
            return this.round(ingredient.quantity * factor);
        },

        normalizeServings() {
            if (!this.servings || this.servings < 0.1) {
                this.servings = 0.1;
                return;
            }

            this.servings = Number(parseFloat(this.servings).toFixed(2));
        },

        round(value, precision = 2) {
            const multiplier = 10 ** precision;
            return Math.round(value * multiplier) / multiplier;
        },

        ingredientName(ingredient) {
            if (ingredient.ingredient_id === 0) {
                return ingredient.comment;
            }

            return ingredient.food_item?.LivsmedelNamn || '';
        },

        ingredientUnit(ingredient) {
            if (ingredient.ingredient_id === 0) {
                return ingredient.unit_text;
            }

            if (ingredient.food_item_unit) {
                return ingredient.food_item_unit.Enhet;
            }

            if (ingredient.unit_id === 0) {
                return 'g';
            }

            return '';
        }
    }
};
</script>
